import React, {useState} from 'react';
import { linkTo } from '../utils/uiUtils';
import { LISTING_TYPE } from '../platformUtils';
import moment from "moment";
// hooks
import useMostPopularProperties from '../hooks/useMostPopularProperties';
import useTrendingProperties from '../hooks/useTrendingProperties';
import useRecommendedProperties from '../hooks/useRecommendedProperties';
import useSearchedProperties from '../hooks/useSearchedProperties';
import useGetListings from '../hooks/useGetListings';
import useProperty from '../hooks/useProperty';

// components
import AcreMap from '../components/AcreMap/AcreMap';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import PropertySearch from '../components/PropertySearch/PropertySearch';
import PropertyCard from '../components/PropertyCard/PropertyCard';


/** TODO - 
 * Will need to only show the listings that are public by querying the propery element in the listing object
 * Will also add a toggle that will allow the user to switch between showing their public and private listings. 
 */

function ExplorePage() {
    const searchedProperties = useSearchedProperties();
    const listings = useGetListings();
    return <>
        <Navbar />
        <div className="sm:h-full-nav-sm md:h-full-nav-md lg:h-full-nav-lg xl:h-full-nav-xl flex flex-col">
            <PropertySearch></PropertySearch>
            <div className="flex flex-grow sm:h-full-search-sm md:h-full-search-md lg:h-full-search-lg xl:h-full-search-xl">
                <div className="flex-grow relative h-full">
                    <AcreMap />
                </div>
                <div className="p-4 overflow-scroll h-full">
                    <div className="text-lg font-bold mb-4">{ listings.length } listings available</div>
                    <ul className="grid grid-cols-2 gap-4">
                        {
                            listings.map(property =>{
                                return <PropertyCard key={`${property.id}`} property={property} size="sm" private={property.listing.is_private} />
                            })
                        }
                    </ul>
                </div>
            </div>
        </div>
        <Footer />
    </>;
}

export default ExplorePage;